// Verbatim what Tailwind emits for the `max-xs:` variant (`xs` is 480px in
// sidecar-design). Written this way rather than as `(max-width: 479px)` so this
// check and the `max-xs:` classes it reasons about flip on exactly the same
// widths — a `max-width` in whole pixels disagrees with the CSS at the
// fractional viewport widths browser zoom and split view produce.
const PHONE_VIEWPORT_QUERY = 'not all and (min-width: 480px)'

/**
 * Whether the viewport is below the Tailwind `xs` breakpoint (480px) — i.e.
 * whether `Poptart`'s `max-xs:` styles are in play.
 *
 * A function, not a hook, on purpose. Its one caller is `openSidekick`, which
 * reads it at the moment the member opens Ash and stores the answer; a hook
 * would re-derive on every render and yank an open panel between layouts when
 * the viewport crossed the breakpoint mid-conversation.
 *
 * Mirrored in `apps/member-app/lib/isPhoneViewport.ts` — the MFE shell has its
 * own copy of the Sidekick provider. Change both.
 *
 * @returns {boolean} Whether the viewport is currently narrower than 480px.
 */
export const isPhoneViewport = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(PHONE_VIEWPORT_QUERY).matches
}
